import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "py-40px px-45px mx-20px bg-hex-F9F9F9CC rounded-5px text-22px <lg:text-14px <lg:leading-18px <sm:text-12px <sm:leading-15px <sm:px-33px <sm:py-35px whitespace-pre-wrap leading-30px" }
const _hoisted_2 = { class: "pl-80px <sm:pl-50px pt-20px <sm:pt-10px pb-40px" }
const _hoisted_3 = { class: "font-600 text-20px <lg:text-14px <sm:text-12px" }
const _hoisted_4 = { class: "ml-15px font-500 text-20px <lg:text-14px <sm:text-12px text-hex-B8B8B8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.name), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.type), 1)
    ])
  ]))
}